<template>
    <!-- BaseFormAlert.vue -->
    <v-alert v-if="value" :data-test="$attrs['data-test'] || 'baseFormAlert'" class="mb-6" type="error">
        <ul>
            <li v-for="(error, i) in errors" :key="`form_alert_item_${i}`">{{ error }}</li>
        </ul>
    </v-alert>
</template>

<script>
    /**
     * Alert component which displays a list of validation errors.  To be used at the top of forms.
     */
    export default {
        name: 'BaseFormAlert',
        props: {
            /**
             * An array of {string} error messages to display i.e. ['Error: message', 'Validation: message']
             */
            errors: {
                type: Array,
                default: () => []
            },
            /**
             * Toggle the visibility of the alert
             */
            value: {
                type: Boolean,
                default: false
            }
        }
    }
</script>
